import { render } from "./NotFound.vue?vue&type=template&id=181395b2"
const script = {}

import exportComponent from "D:\\node\\电脑版Windous\\myOfficial\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__